module.exports = __webpack_public_path__ + "img/Picture8.485b928c.png";